import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import Layout from '../components/Layout';
import moment from 'moment';
import { FacebookProvider, Comments } from 'react-facebook';
import Feedback from '../components/thuatngu/Feedback';
import TopTerm from '../components/thuatngu/TopTerm';
import { Link } from '../server/pages';
import Search from '../components/Search';
import { commonConst, FACEBOOK_APP_ID } from '../constants/constants';
import { isEmpty } from '../utils/utils';
import { combineTitle, combineTitleHeading } from '../routines/home_routines';
import parse from 'html-react-parser';
import { Folder } from 'react-feather';
import { useRouter } from 'next/router';
import { Spinner } from 'react-bootstrap';
import * as queryString from 'query-string';

const fetch = require('isomorphic-fetch');
const ROOT_API = process.env.ROOT_API;

export async function getServerSideProps({ query }) {
  const { defaultLang } = commonConst;
  const { slug, hl } = query || {};
  let id;
  if (!isEmpty(slug)) {
    id = slug.split('-')[slug.split('-').length - 1];
  }

  let termDetail = null;
  let topTerms = null;
  let relativeTerms = null;
  let categories = null;

  let text = null;

  const res = await fetch(`${ROOT_API}term/${id}`);
  if (!isEmpty(res)) {
    termDetail = await res.json();
    text = termDetail.title;
    if (!isEmpty(hl) && hl === 'en') {
      text = termDetail.titleEn;
    }
  }
  const topTermsAPI = await fetch(`${ROOT_API}term/views?pageIndex=1&pageSize=10`);
  if (!isEmpty(topTermsAPI)) {
    topTerms = await topTermsAPI.json();
  }

  const relativeTermsAPI = await fetch(
    `${ROOT_API}term/with-text?text=${encodeURI(text)}&lang=${hl}&exceptionIds=${id}&pageIndex=1&pageSize=10`,
  );
  if (!isEmpty(relativeTermsAPI)) {
    relativeTerms = await relativeTermsAPI.json();
  }

  const category = await fetch(`${process.env.ROOT_API}category`);
  if (!isEmpty(category)) {
    categories = await category.json();
  }

  return { props: { termDetail, topTerms, categories, relativeTerms, hl: !isEmpty(hl) ? hl : defaultLang } };
}

function Detail(props) {
  const router = useRouter();
  const { hl: currentHl, termDetail, topTerms, relativeTerms, categories } = props || {};
  const { defaultAlphabet, defaultCategory, defaultText } = commonConst;
  const [alphabet, setAlphabet] = useState(defaultAlphabet);
  const [catId, setCategory] = useState(defaultCategory);
  const [hl, setLanguage] = useState(currentHl);
  const [text, setText] = useState(defaultText);
  const { title, titleEn, define, link, id } = termDetail;
  const relatives = relativeTerms.results;

  const handleCategoryChange = async value => {
    const qs = queryString.stringify({
      ...(!isEmpty(value) && { catId: value }),
      ...(hl === 'en' && { hl }),
      page: 1,
    });
    router.push({
      pathname: '/thuat-ngu',
      query: qs,
    });
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const userHistory = JSON.parse(window.localStorage.getItem('vnb-user-history'));
      if (!isEmpty(userHistory)) {
        userHistory.forEach((history, index) => {
          const { termId, lastVisit } = history || {};
          const currentTime = moment(moment(), 'DD-MM-YYYY HH:mm:ss');
          const oldTime = moment(moment(lastVisit, 'DD-MM-YYYY HH:mm:ss'));
          const diffTime = currentTime.diff(oldTime, 'minutes');
          if (diffTime >= 30) {
            if (termId !== id) {
              userHistory.splice(index, 1);
              window.localStorage.setItem('vnb-user-history', JSON.stringify(userHistory));
            } else {
              fetch(`${ROOT_API}term/${id}`, {
                method: 'PUT',
              });
              history.lastVisit = moment().format('DD-MM-YYYY HH:mm:ss');
              window.localStorage.setItem('vnb-user-history', JSON.stringify(userHistory));
            }
          }
        });
      } else {
        window.localStorage.setItem(
          'vnb-user-history',
          JSON.stringify([{ termId: id, lastVisit: moment().format('DD-MM-YYYY HH:mm:ss') }]),
        );
        fetch(`${ROOT_API}term/${id}`, {
          method: 'PUT',
        });
      }
    }
  });

  return (
    <Layout>
      <Head>
        <title>{combineTitle(hl, title, titleEn)}</title>
        <meta name="description" content={define} />
        <meta property="og:title" content={`${combineTitle(hl, title, titleEn)} | Thuật ngữ VietnamBiz`} />
        <meta property="og:description" content={define} />
        <meta property="og:image" content={`${process.env.WEBSITE_URL}static/img/logo/vnbz-300x300.png`} />
        <meta property="og:url" content={`${process.env.WEBSITE_URL}${router.asPath.replace('/', '')}`} />
        <meta property="og:site_name" content="Thuật ngữ VietnamBiz" />
        <script async src="https://www.googletagmanager.com/gtag/js?id=UA-146891693-2" />

        <script
          dangerouslySetInnerHTML={{
            __html: `window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments)}
            gtag('js', new Date());
            gtag('config', 'UA-146891693-2');`,
          }}
        />
      </Head>
      <Search
        cats={categories}
        alphabet={alphabet}
        catId={catId}
        hl={hl}
        text={text}
        setAlphabet={setAlphabet}
        setLanguage={setLanguage}
        setCategory={setCategory}
        setText={setText}
      />
      <div className="container">
        <div className="term__content">
          <div className="row ">
            <div className="col-lg-8">
              {!combineTitle(hl, title, titleEn) && (
                <div className="loader-placehodler-1 d-flex justify-content-center">
                  <Spinner animation="border" variant="dark" className="opacity-20" />
                </div>
              )}

              <div className="pr-lg-4 mt-lg-3">
                <div className="glossary-detail">
                  <h2 className="tt text-primary">{parse(combineTitleHeading(hl, title, titleEn))}</h2>

                  <div className="glossary__cat">
                    <div className="glossary__cat__icon">
                      <Folder /> Lĩnh vực :
                    </div>
                    {termDetail.categories.map(item => (
                      <div className="glossary__cat__item" key={item.id}>
                        <span className="link" onClick={() => handleCategoryChange(item.id)}>
                          {item.title}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div className="cluster__heading is__dash__left mt-4">
                    <h3 className="cluster__title text-uppercase ">Định nghĩa</h3>
                  </div>
                  <div className="glossary-content" dangerouslySetInnerHTML={{ __html: define }} />
                  <div className="mt-2 mt-lg-3 text-left">
                    <a className="news__source" rel="noopener noreferrer" target="_blank" href={link}>
                      Xem chú giải đầy đủ
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-external-link icon"
                      >
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                        <polyline points="15 3 21 3 21 9" />
                        <line x1={10} y1={14} x2={21} y2={3} />
                      </svg>
                    </a>
                  </div>
                  <Feedback termId={id} />
                  <div className="comments mt-5 w-100 overflow-hidden">
                    <FacebookProvider appId={FACEBOOK_APP_ID}>
                      <Comments href={`${process.env.WEBSITE_URL}${id}`} />
                    </FacebookProvider>
                  </div>
                  {relatives && relatives.length > 0 && (
                    <div className="mt-5 ">
                      <div className="cluster__heading is__dash__left mt-5">
                        <h3 className="cluster__title text-uppercase ">Các thuật ngữ liên quan</h3>
                      </div>

                      <ul className="pl-4 pr-0 pr-lg-5">
                        {relatives.map(item => {
                          const { title, titleEn, slugEn, slug, id } = item;
                          return (
                            <li key={title} className="mb-3">
                              <Link
                                route="detailRoute"
                                params={{
                                  slug: hl === 'en' ? `${slugEn}-${id}` : `${slug}-${id}`,
                                  ...(hl === 'en' && { hl }),
                                }}
                              >
                                {hl === 'vn' ? title : titleEn}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-4 pb-4 pb-lg-5">
              <TopTerm hl={hl} terms={topTerms} />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
export default Detail;
